import { CommonModule } from '@angular/common';
import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { PipesModule } from '../../pipes/pipes.module';
import { MaterialModule } from '../../material/material.module';
import { isObject } from '@pineapplelab/util';

export interface TextToShow {
  title: string;
  description: string;
  acceptBtnText: string;
  dismissBtnText: string;
  btnColor: 'danger' | 'primary'
  acceptBtnDisable: boolean;
  dismissBtnDisable: boolean;
  titleParams: { params: { [key: string]: any } }
}

@Component({
  selector: 'app-generic-alert-popup',
  standalone: true,
  imports: [
    CommonModule,
    MatDialogModule,
    MaterialModule,
    PipesModule
  ],
  templateUrl: './generic-alert-popup.component.html',
  styleUrl: './generic-alert-popup.component.scss'
})
export class GenericAlertPopupComponent implements OnInit {

	areThereTitleParams: boolean = false;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: TextToShow,
    private dialogRef: MatDialogRef<GenericAlertPopupComponent>
  ) {}

  ngOnInit(): void {
	this.areThereTitleParams = !!this.data?.titleParams && isObject(this.data?.titleParams) && !!Object.keys(this.data?.titleParams).length;
  }

  dismiss() {
    this.dialogRef.close(null);
  }

  decline(){
    this.dialogRef.close(false);
  }

  accept() {
    this.dialogRef.close(true);
  }

}
